import React from 'react';
import { Spring } from 'react-spring/renderprops.cjs';
import { AnimationContainer } from './styled';

const GrowContainer = ({ type, toggle, from, to, style, children }) => (
  <Spring
    from={{
      [type]: from,
      opacity: 0,
    }}
    to={{
      [type]: toggle ? to : from,
      opacity: toggle ? 1 : 0,
    }}
    config={{
      mass: 1,
      tension: 170,
      friction: 26,
    }}
  >
    {props => (
      <AnimationContainer {...props} style={style}>
        {React.Children.map(children, child => React.cloneElement(child, {
          ...props,
        }))}
      </AnimationContainer>)}
  </Spring>);

export default GrowContainer;
